<template>
  <div class="MeinServiceContainer">
    <Header name="Profil erstellen"/>
    <!-- GoBackToProfil  GoToServiceAnmelden-->
    <div class="header cursor-pointer" @click="$emit('GoBackToProfil')">
      <SVGIcon size="small" name="arrow_back_blue" class="selfAlignCenter"/>
      <div class="headerText colorBlue">zurück</div>
    </div>
    <!-- <div class="selfAlignCenter">Mein Profil speichern</div> -->
    <p class="colorRed" v-if="!pin && !isLoading">Es trat ein Fehler beim Erzeugen des Services auf. Bitte versuchen Sie es später erneut.</p>
    <div v-else>
      <div class="content">
        <div
          v-if="tooltipOpen"
          class="backgroundGrey padding10 borderRadius10"
          style="position:absolute"
        >
          <div class="displayflex flexbetween">
            <SVGIcon name="id_transfer" size="big" style="width:100px"/>
            <SVGIcon
              name="close"
              size="small"
              class="cursor-pointer"
              @click.native="tooltipOpen = false"
            />
          </div>
          <p>
            Um Ihre Kartenansicht, Ihre Routen und Benachrichtigungen auf einem anderen Gerät zu nutzen oder
            dauerhaft zu speichern, können Sie sich eine Profilnummer geben lassen.
          </p>
          <p>
            Mit dieser Profilnummer und Ihrem Passwort können Sie Ihre Einstellungen, Routen und Benachrichtigungen
            jederzeit und überall auf einem anderen Gerät, z.B. einem Mobiltelefon wieder herstellen.
            Es werden hierfür keine persönlichen Daten von uns gespeichert.
          </p>
        </div>

        <div class="displayflex flexend">
          <!-- Erklärung -->
          <p
            style="width:calc(100% - 50px); margin-right:25px;"
            class="colorLightGrey fontsize16 marginbottom15"
          >
            Um Ihre Routen und Benachrichtigungen auf einem anderen Gerät zu nutzen oder dauerhaft zu speichern,
            geben Sie bitte ein Passwort ein.
          </p>
          <SVGIcon
            name="fragezeichen"
            class="cursor-pointer"
            size="little"
            @click.native="tooltipOpen = true"
          />
        </div>

        <div class="colorRed">Wichtig:</div>
        <p class="colorLightGrey fontsize16">Bitte notieren Sie sich Nummer und Passwort</p>

        <!-- Pin Anzeige -->
        <p class="colorLightGrey fontsize16 marginbottom15">Ihre Profilnummer</p>
        <p class="colorRed fontsize16 marginbottom15 fontweight600">{{pin}}</p>
        <!-- Passworteingabe -->
        <input
          ref="passwort"
          :bind="passwort"
          @input="passwort = $event.target.value"
          :value="passwort"
          type="password"
          name="passwort"
          id="passwort"
          placeholder="Ihr Passwort*"
          class="colorBlue borderBlue borderBottom fontweight600"
          @click="focus('passwort')"
        >
        <!-- Buttom zum senden des PINs und des Passworts an die eingegebene Email -->
        <!-- <p
        class="colorLightGrey fontsize16 marginbottom15 margintop15"
      >Optional können wir Ihre Profilnummer und Passwort an die von Ihnen eingegebene E-Mail senden. Ihre E-Mail Adresse wird dabei nicht gespeichert.</p>
      <input
        :bind="email"
        @input="email = $event.target.value"
        :value="email"
        type="email"
        name="email"
        id="email"
        placeholder="Ihre E-Mail (optional)"
        class="colorBlue borderBlue borderBottom fontweight600"
        >-->
        <!-- Button zum erstellen des Services -->
        <div
          :class="['borderWidth1 borderStyleSolid borderRadius30 padding10 textcenter cursor-pointer margin20_40', pin ? 'colorBlue borderBlue' : 'colorDarkGrey borderDarkGrey']"
          @click="pin ? serviceErstellen() : ''"
        >{{!pin && isLoading ? 'Profilnummer wird geladen...' : 'Profil erstellen' }}</div>

        <!--

            <div class="colorBlue borderBlue borderWidth1 borderStyleSolid borderRadius30 padding10 textcenter cursor-pointer margin20_40">
                Senden
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./../CoreComponents/Header.vue";

export default {
  components: { Header },
  name: "MeinServiceErstellen",
  data: function() {
    return {
      tooltipOpen: false,
      passwort: null,
      email: null
    };
  },
  mounted() {
    if (!this.pin) {
      this.$store.dispatch("getPin");
    }
  },
  computed: {
    pin() {
      return this.$store.state.userPin;
    },
    isLoading() {
      return this.$store.state.isLoading;
    }
  },
  methods: {
    focus(focusRef) {
      this.$refs[focusRef].focus();
    },

    serviceErstellen() {
      if (!this.pin) {
        this.$store.dispatch(
          "sendNotificationError",
          "Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut."
        );
        return;
      }
      if (!this.passwort) {
        this.$store.dispatch(
          "sendNotificationError",
          "Bitte geben Sie ein Passwort ein"
        );
        return;
      }
      if (this.passwort.length < 5) {
        this.$store.dispatch(
          "sendNotificationError",
          "Bitte geben Sie ein Passwort mit mindestens 5 Zeichen ein"
        );
        return;
      }

      if (this.email && !this.checkEmailValidity()) {
        this.$store.dispatch(
          "sendNotificationError",
          "Bitte geben Sie eine gültige E-Mail Adresse ein"
        );
        return;
      }

      const obj = {
        passwort: this.passwort,
        pin: this.pin
      };
      if (this.email) {
        obj.email = this.email;
      }

      this.$store.dispatch("serviceErstellen", obj);
    },

    checkEmailValidity() {
      if (
        !/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        )
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.MeinServiceContainer {
  position: relative;
}
.header {
  display: flex;
  margin-bottom: 15px;
}

.headerText {
  display: flex;
  flex-direction: column;
  align-self: center;
  margin-left: 30px;
}
</style>
